// @ts-strict-ignore
import { Pagination } from './Pagination'
import React from 'react'
import { ClassValue } from 'classnames/types'
import { Params } from './useTableHooks'
import { PerPageSelect } from './PerPageSelect'
import { observer } from 'mobx-react-lite'
import { toJS } from 'mobx'

interface TableBottomSectionProps {
    pagination?: Pagination
    paginationClassname?: ClassValue
    stickyFooterSection?: object
    loading?: boolean
    showPerPage?: boolean
    perPage: number
    setPerPage: any
    perPageLabel: string
    params: Params
    setParams: any
    isWidget?: boolean
}

export const TableBottomSection = observer(
    ({
        pagination,
        paginationClassname,
        stickyFooterSection,
        loading,
        showPerPage,
        perPage,
        setPerPage,
        perPageLabel,
        params,
        setParams,
        isWidget = false,
    }: TableBottomSectionProps) => {
        if (!pagination) {
            return null
        }

        const from = pagination.from ?? 0
        const to = pagination.to ?? 0
        const total = pagination.total ?? 0

        return (
            <div
                id={isWidget ? 'table-bottom-section-widget' : 'table-bottom-section'}
                className={
                    'd-flex align-items-center justify-content-between mt-4 ' + paginationClassname
                }
                style={{ ...stickyFooterSection }}
            >
                <div
                    id="bottom-left-section"
                    className={loading ? 'bp4-skeleton text-xs' : 'text-xs'}
                >
                    Displaying {from}-{to} of {total}
                </div>
                <div id="bottom-right-section" className="d-flex align-items-center">
                    {showPerPage &&
                    pagination.current &&
                    pagination.total &&
                    pagination.total > 0 ? (
                        <PerPageSelect
                            value={perPage}
                            onChange={(e) => {
                                setParams((prev) => ({
                                    ...prev,
                                    page: 1,
                                }))
                                setPerPage(e.target.value)
                            }}
                            label={perPageLabel}
                            minimal
                            className="mr-4"
                        />
                    ) : null}
                    <Pagination
                        className=""
                        minimal
                        loading={loading}
                        current={pagination.current}
                        total={pagination.last_page}
                        onClick={(page) =>
                            setParams
                                ? setParams({
                                      ...params,
                                      page,
                                  })
                                : null
                        }
                    />
                </div>
            </div>
        )
    },
)

export const BootstrappedTableBottomSection = observer(
    ({
        pagination,
        paginationClassname,
        stickyFooterSection,
        loading,
        showPerPage,
        perPage,
        setPerPage,
        perPageLabel,
        params,
        setParams,
    }: TableBottomSectionProps) => {
        if (!pagination) {
            return null
        }

        const from = pagination.from ?? 0
        const to = pagination.to ?? 0
        const total = pagination.total ?? 0

        return (
            <div
                className={'d-flex justify-content-between ' + paginationClassname}
                style={{ ...stickyFooterSection }}
            >
                <div id="bottom-left-section" className={loading ? 'bp4-skeleton' : 'text-xs mt-2'}>
                    Displaying {from}-{to} of {total}
                </div>
                <div id="bottom-right-section">
                    {showPerPage &&
                        pagination.current &&
                        pagination.total &&
                        pagination.total > 0 && (
                            <PerPageSelect
                                value={perPage ?? 15}
                                onChange={(e) => {
                                    setParams((prev) => ({
                                        ...prev,
                                        page: 1,
                                    }))
                                    setPerPage(e.target.value)
                                }}
                                label={perPageLabel}
                                minimal
                                className="float-left mr-4"
                            />
                        )}
                    <Pagination
                        className="float-left"
                        minimal
                        loading={loading}
                        current={pagination.current}
                        total={pagination.last_page}
                        onClick={(page) =>
                            setParams
                                ? setParams({
                                      ...params,
                                      page,
                                  })
                                : null
                        }
                    />
                </div>
            </div>
        )
    },
)

export const BootstrappedTableBottomSectionSmall = observer(
    ({
        pagination,
        paginationClassname,
        stickyFooterSection,
        loading,
        showPerPage,
        perPage,
        setPerPage,
        perPageLabel,
        params,
        setParams,
    }: TableBottomSectionProps) => {
        if (!pagination) {
            return null
        }

        return (
            <div
                className={'d-flex justify-content-between ' + paginationClassname}
                style={{ ...stickyFooterSection }}
            >
                <div id="bottom-left-section" className={loading ? 'bp4-skeleton' : 'text-xs mt-2'}>
                    Displaying {pagination.from}-{pagination.to} of {pagination.total}
                </div>
                <div id="bottom-right-section">
                    {showPerPage &&
                        pagination.current &&
                        pagination.total &&
                        pagination.total > 0 && (
                            <PerPageSelect
                                value={perPage ?? 15}
                                onChange={(e) => {
                                    setParams((prev) => ({
                                        ...prev,
                                        page: 1,
                                    }))
                                    setPerPage(e.target.value)
                                }}
                                label={perPageLabel}
                                minimal
                                className="float-left mr-4"
                                small
                            />
                        )}
                    <Pagination
                        small
                        className="float-left"
                        minimal
                        loading={loading}
                        current={pagination.current}
                        total={pagination.last_page}
                        onClick={(page) =>
                            setParams
                                ? setParams({
                                      ...params,
                                      page,
                                  })
                                : null
                        }
                    />
                </div>
            </div>
        )
    },
)
